/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selector_Teams_None_YetInputs */



/**
* | output |
* | --- |
* | "No teams have been created yet. Create one under Teams to pick a whole team here." |
*
* @param {Selector_Teams_None_YetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const selector_teams_none_yet = /** @type {((inputs?: Selector_Teams_None_YetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selector_Teams_None_YetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurde noch kein Team erstellt. Legen Sie unter „Teams“ eines an, um hier ein ganzes Team auszuwählen.")
	return /** @type {LocalizedString} */ ("No teams have been created yet. Create one under Teams to pick a whole team here.")
});